<div class="honda-screen">
    <div *ngIf="isRenew" class="top-ribbon">
        <p class="header-text">{{displayedText.trialExpiringSoonMessage}}</p>
    </div>
    <div class="layout">
    <div class="left-section" [ngClass]="{'if-renew': isRenew}">
        <div class="left-container" [ngClass]="{'if-canada':country === 'CA'}">
            <h2 *ngIf="!isRenew" class="top-text" style="white-space: pre-line;">{{displayedText.activateText}}</h2>
            <h2 *ngIf="isRenew" class="top-text" style="white-space: pre-line;">{{displayedText.subscribeText}}</h2>
            <qrcode *ngIf="url"  [width]="200" [qrdata]="url" [errorCorrectionLevel]="'M'" [size]="200"  class="qrcodeImage"></qrcode>
            <p  *ngIf="!isRenew" class="bottom-text" style="white-space: pre-line;">{{displayedText.scanMessage.trial}}</p>
            <p *ngIf="isRenew" class="bottom-text" style="white-space: pre-line;">{{displayedText.scanMessage.subscription}}</p>
            <div class="toggle-container" *ngIf="country === 'CA'">
                <span class="toggle-text">{{displayedText.englishLanguageTitle}}</span>
                <label class="toggle-switch">
                    <input type="checkbox"  
                    (change)="onLanguageChange($event)"/>
                    <span class="slider"></span>
                    </label>
                <span class="toggle-text">{{displayedText.frenchLanguageTitle}}</span>
              </div>
        </div>
    </div>
    <div class="center-phone" [ngClass]="{'if-renewMobile': isRenew}">
    <img  *ngIf="country === 'US'" src="..\assets\ivi23\mobile.png"  alt="Phone" class="phone-img"/>
    <img  *ngIf="selectedLanguage === 'en' && country === 'CA'" src="..\assets\ivi23\HL-en-Mobile.png" alt="Phone" class="phone-img" />
    <img  *ngIf="selectedLanguage === 'fr'" src="..\assets\ivi23\HL-fr-Mobile.png" alt="HL Phone" class="phone-img" />
    </div>
    <div class="right-panel" [ngClass]="{'if-renewRightPanel': isRenew}">
    <div class="rectangle3"></div>
    <div class="row">
    <img src="..\assets\ivi23\black car.png" alt="Black Car" class="car-img panel-image image-1" />
    <img src="..\assets\ivi23\remote start.png" alt="remote start" class="remote-start" />
    <img *ngIf="selectedLanguage === 'fr'" src="..\assets\ivi23\HL-fr-RemoteStart.png" alt="HL remote start" class="remote-start"/>
    </div>
    <div >
    <img src="..\assets\ivi23\white car.png" alt="White Car" class="combined-image panel-image image-2" />
    <img src="..\assets\ivi23\remote lock.png" alt="remote lock" class="remote-lock" />
    <img *ngIf="selectedLanguage === 'fr'" src="..\assets\ivi23\HL-fr-RemoteLock.png"  alt="HL remote lock" class="remote-lock"  />
    <img src="..\assets\ivi23\civic car.png" alt="Civic car" class="civic-car" />
    </div>
    <div class="rectangle">
        <img src="..\assets\ivi23\white-rectangle.png" alt="rectangle" />
    </div>
    <div class="row">
        <div class="btm-img panel-image image-3">
            <img src="..\assets\ivi23\Map-image.png" alt="map" class="map-img" /> 
            <div class="blur-overlay"></div>           
        </div>
    <img src="..\assets\ivi23\vehicle locator.png" alt="vehicle locator" class="vehicle-locator" />
    <img *ngIf="selectedLanguage === 'fr'" src="..\assets\ivi23\AL-fr-VehicleLocator.png" alt="HL vehicle locator" class="vehicle-locator"  />
    </div>
</div>
</div>
</div>